import { DEFAULT_LOCALE } from '@constants';
import api from '..';
import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

export const useChaptersList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'chapters', api: api.chapters }, queryVariables, queryConfig);

  return {
    chapters: queryResult.resolvedData,
    latestChapters: queryResult.latestData,
    ...queryResult,
  };
};

export const useChaptersByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['chapters', { ids }], api.chapters.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    chapters: queryResult.data || [],
    ...queryResult,
  };
};

export const useChapter = ({ id, locale = DEFAULT_LOCALE }, queryConfig = {}) => {
  const queryResult = useQuery(['chapter', { id, locale }], api.chapters.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    chapter: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'chapters' });

export const useDeleteChapter = createMutation(api.chapters.remove);

export const useCreateChapter = createMutation(api.chapters.create);

export const useUpdateChapter = createMutation(api.chapters.update);

export const usePublishChapter = createMutation(api.chapters.publish);

export const useUnpublishChapter = createMutation(api.chapters.unpublish);

export const useDuplicateChapter = createMutation(api.chapters.duplicate);
